import store from 'store';

function onboardingIsSeen (onboardingId) {
  return store.getters['releaseNotes/onboardingIsSeen'](onboardingId);
}

export default onboardingIsSeen;
